import { FC } from "react";
import { Accordion } from "@app/shared/Accordion";
import { SubmissionCommentDisplay } from "@app/compliance-connect/network-submission/interfaces";
import { NetworkProfileCommentEntry } from "@app/compliance-connect/issuer/network-profile/NetworkProfileCommentEntry";

interface NetworkProfileCommentSectionProps {
  comments: SubmissionCommentDisplay[];
  emptyMessage: string;
  onCommentViewed?: (submissionCommentId: number) => void;
  testId: string;
  title: string;
}

export const NetworkProfileCommentSection: FC<NetworkProfileCommentSectionProps> = ({
  comments,
  emptyMessage,
  onCommentViewed,
  testId,
  title,
}) => (
  <Accordion
    className="compliance-connect-network-profile__comment-section"
    defaultOpen
    testId={testId}
    title={`${title} (${comments.length})`}
  >
    <div data-testid={`${testId}-entries`}>
      {comments.length === 0 && (
        <p className="compliance-connect-network-profile__comment-empty" data-testid={`${testId}-empty`}>{emptyMessage}</p>
      )}
      {comments.map(comment => (
        <NetworkProfileCommentEntry
          key={comment.submissionCommentId}
          comment={comment}
          onView={onCommentViewed}
        />
      ))}
    </div>
  </Accordion>
);
